import AdminMenu from "./AdminMenu";
import OptionsMenu from "./OptionsMenu";
import NavOption from "../NavOption";
import styles from "./NavMenu.module.css";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import React, { useEffect } from "react";
import AuditReportsMenu from "./AuditReportsMenu";

const NavMenu = ({ ACTIONS, dispatch, state, closeMenus }) => {
  // eslint-disable-next-line
  const { width, height } = useWindowDimensions();

  useEffect(() => {
    if (width > state.MAX_MOBILE_SCREEN_WIDTH) {
      dispatch({ type: ACTIONS.SET_NAV_CLASS, value: styles.nav });
      if (state.mobileMenuOpen === true) {
        dispatch({ type: ACTIONS.CLOSE_MENUS });
      }
    } else {
      dispatch({
        type: ACTIONS.SET_NAV_CLASS,
        value: state.mobileMenuOpen ? styles.navMobileFocused : styles.nav,
      });
    }
    //eslint-disable-next-line
  }, [width, state.mobileMenuOpen]);

  return (
    <ul className={state.navClass}>
      <NavOption
        classOverride={styles.titleOption}
        displayText={"Home"}
        navigateTo={"/home"}
        ACTIONS={ACTIONS}
        dispatch={dispatch}
        state={state}
        closeMenus={closeMenus}
      />
      <AdminMenu
        ACTIONS={ACTIONS}
        dispatch={dispatch}
        state={state}
        closeMenus={closeMenus}
      />
      <AuditReportsMenu
        ACTIONS={ACTIONS}
        dispatch={dispatch}
        state={state}
        closeMenus={closeMenus}
      />
      <OptionsMenu
        ACTIONS={ACTIONS}
        dispatch={dispatch}
        state={state}
        closeMenus={closeMenus}
      />
    </ul>
  );
};

export default NavMenu;
